import React, { useState, useMemo } from 'react';
import { createPortal } from 'react-dom';
import { useFloating, useInteractions, useClick, useDismiss, useRole, flip } from '@floating-ui/react';
import clsx from 'clsx';
import styles from './Dropdown.module.scss';
const Dropdown = ({ className, children, options, placement = 'bottom-start' })=>{
    const [isOpen, setIsOpen] = useState(false);
    const { refs, floatingStyles, context } = useFloating({
        open: isOpen,
        middleware: [
            flip()
        ],
        strategy: 'fixed',
        onOpenChange: setIsOpen,
        placement: placement
    });
    const click = useClick(context);
    const dismiss = useDismiss(context);
    const role = useRole(context);
    const { getReferenceProps, getFloatingProps, getItemProps } = useInteractions([
        click,
        dismiss,
        role
    ]);
    const visibleOptions = useMemo(()=>options.filter((item)=>!item.hidden), [
        options
    ]);
    const optionElements = visibleOptions.map((item, index)=>/*#__PURE__*/ React.createElement("div", {
            className: clsx(styles.menuItem, {
                [styles.disabled]: item.disabled
            }),
            key: index,
            onClick: ()=>{
                var _item_onClick;
                if (item.disabled == true) {
                    return;
                }
                (_item_onClick = item.onClick) === null || _item_onClick === void 0 ? void 0 : _item_onClick.call(item);
                setIsOpen(false);
            },
            ...getItemProps()
        }, item.label));
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("button", {
        className: clsx(styles.menuButton, className),
        ref: refs.setReference,
        ...getReferenceProps()
    }, children), isOpen == true && /*#__PURE__*/ createPortal(/*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.menuItems),
        ref: refs.setFloating,
        style: floatingStyles,
        ...getFloatingProps()
    }, optionElements), document.body));
};
export { Dropdown };
